import _ from 'underscore';
import queryString from 'query-string';
import stringify from 'json-stable-stringify';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type { AccountVariables, TopUpLimit } from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<AccountVariables, null>) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid, aid } = descriptor;

  const search = {
    uid,
    cid,
    accountId: aid,
    customerId: cid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/PaymentUtility/TopUpLimit${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<AccountVariables, null>({
  schema,
  dataPath: 'user:customer:account:top_up_limit',
  verb: requestVerbs.GET,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  parentKeySelector: variables => variables.locator.descriptor.aid,
});

export const fetchResponseContract = createResponseContract<
  AccountVariables,
  null,
  TopUpLimit,
  TopUpLimit[],
  TopUpLimit[]
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,
  keySelector: topUpLimit => stringify(topUpLimit),
  processorFn: response => response,
});
